import {
  SET_COLLECTION_TO_USE,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  collectionToUse: 'companies',
}

const collectionToUseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_COLLECTION_TO_USE: {
      return {
        ...state,
        collectionToUse: action.payload,
      }
    }
    default:
      return state
  }
}

export default collectionToUseReducer
